export const SET_HOTEL = 'ROOMLIST/SET_HOTEL'
export const SET_HOTELS = 'ROOMLIST/SET_HOTELS'
